export interface User {
  id: string;
  name: string;
  gender: string;
  birthDate: string;
  address: string;
  addressType: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
  countryOrigin: string;
  phone: string;
  policy: string;
  fax: string;
  email: string;
  customer: string;
  externalId: string;
  profilePictureUrl: string;
  observations: string;
  centre: string;
  academicYear: string;
  trainingCycle: string;
  course: string;
  courseGroup: string;
  company: string;
  position: string;
  contactPerson: string;
  autoAcceptHolds: boolean;
  termsAccepted: boolean;
  tutorsFilled: boolean;
  lastLogin: Date;
  locale: string;
  session: string;
  showRecommendations: boolean;
  interestsFilled: boolean;
  currentPassword?: string;
  newPassword?: string;
  canCreateUserGroups: boolean;
  canCreateExperiences: boolean;
  canCreatePublicLists: boolean;
  accessToken?: string;
  idToken?: string;
  role?: string;
  category?: string;
  afiliated?: string;
  allowEmails: boolean;
  origin: string;
  isManager: boolean;
  groupManager: boolean;
}

export const MAXLENGTH_DEPARTAMENTO = 100;

export interface UserBadge {
  pictureUrl: string;
  color: string;
  content: string;
}

export interface UserSignUp {
  userId: string;
  status: UserSignUpStatus;
}

export type UserSignUpStatus = 'OK' | 'NEEDS_VALIDATION' | 'NEEDS_APPROVAL' | 'NEEDS_ACCOUNT_VALIDATION';

export interface SimpleLocation {
  lat: number;
  lng: number;
}

export type ExternalLoginType = 'DIBAM' | 'SAML2' | 'OAUTH2' | 'EZPROXY' | 'CAS' | 'OTK' | 'LEIASP' | 'CUSTOM_SSO' | 'UNKNOWN';

export interface RemoteLoginResponse {
  user?: User;
  redirectTo?: string;
}

export enum VerifyAccountStatus {
  OK = 'OK',
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  ERROR = 'ERROR',
  NEEDS_VALIDATION = 'NEEDS_VALIDATION',
}

export interface UserGroup {
  groupId?: string;
  clientCode?: string;
  name?: string;
  ownerId?: string;
  memberIdentifiers?: string[];
  managerIdentifiers?: string[];
  filters?: UserFilter[];
  autoUpdate?: boolean;
  color?: string;
  rejectedMembers?: string[];
  typeUser?: TypeUser;
  enabledNotifications?: boolean;
}

export interface UserGroupCollectionsResponse {
  is_member: UserGroup[];
  is_owner: UserGroup[];
  is_manager: UserGroup[];
}

export interface UserFilter {
  id?: string;
  values?: string[];
  name?: string;
}

export interface AvailableFilter {
  id?: string;
  values?: string[];
  name?: string;
}

export enum TypeUser {
  UNIQUE_NUMBER, // Numero unico
}
